import { configureStore } from '@reduxjs/toolkit';

import GenesisUserRolePermission from './reducers/GenesisUser';
import Theme from './Theme';
import Toggle from './reducers/Toggle';
import Locations from './reducers/Locations';
import ActivityMaintence from './reducers/Activities';
import Counterparty from './reducers/Counterparty';
import Units from './reducers/Unit';
import Nominations from './reducers/Nominations';
import AdjacentTSO from './reducers/AdjacentTSO';
import Audit from './reducers/AuditLogs';
import SwingContract from './reducers/SwingContract';
import BeachSwingAndTrades from './reducers/BeachSwingAndTrades';
import SwingNomsByContract from './reducers/SwingNomsByContract';
import ProducerConfig from './reducers/ProducerConfig';
import Dashboard from './reducers/Dashboard';
import Notifications from './Notifications';
import ShipperActuals from './reducers/ShipperActuals';
import ProducerDeliveries from './reducers/ProducerDeliveries';
import Tradings from './reducers/Trading';
import BeachChecks from './reducers/BeachChecks';
import CounterpartyStatementsConfig from './reducers/CounterpartyStatementsConfig';
import Automation from './reducers/AutomationConfiguration';
import CounterpartyStatementsDetails from './reducers/CounterpartyStatements';
import FieldNoms from './reducers/Nominations/FieldNoms';
import BeachSwaps from './reducers/BeachSwaps';
import FieldNomsSwingContract from './reducers/FieldNomsSwingContract';
import EOSAudit from '../components/EOS/store/slices/Audit';
import forecastAnalysis from '../components/EOS/store/slices/ForecastAnalysis';
import scenarioAnalysis from '../components/EOS/store/slices/ScenarioAnalysis';
import dashboardEOS from '../components/EOS/store/slices/dashboard';
import reportTypes from '../components/EOS/store/slices/reportTypes';
import mappingConfig from '../components/EOS/store/slices/mappingConfig';
import eosUser from '../components/EOS/store/slices/eosUser';
import UserDashboardPreferences from './reducers/UserDashboardPreferences';
import MarketPositionNew from './reducers/MarketPositionNew';
import ContractViewNew from './reducers/ContractViewNew';
import JobLookups from './reducers/JobLookups';

const store = configureStore({
  reducer: {
    Notifications,
    Theme,
    Toggle,
    genesisUserRolePermission: GenesisUserRolePermission,
    Locations,
    Counterparty,
    ActivityMaintence,
    Units,
    Nominations,
    AdjacentTSO,
    Audit,
    SwingContract,
    BeachSwingAndTrades,
    SwingNomsByContract,
    Dashboard,
    ProducerConfig,
    ShipperActuals,
    ProducerDeliveries,
    Tradings,
    BeachChecks,
    CounterpartyStatementsConfig,
    Automation,
    CounterpartyStatementsDetails,
    FieldNoms,
    BeachSwaps,
    FieldNomsSwingContract,
    userDashboardPreferences: UserDashboardPreferences,
    dashboardEOS,
    EOSAudit,
    forecastAnalysis,
    scenarioAnalysis,
    reportTypes,
    mappingConfig,
    eosUser,
    MarketPositionNew,
    ContractViewNew,
    JobLookups,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['forecastAnalysis.dateRange'],
        ignoredActions: ['forecastAnalysis/setDateRange'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
